<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaLojistas"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="lojistaSelecionado"
          :items="lojistas"
          item-text="nome"
          item-value="id"
          label="Selecione o lojista"
          @input="carregaProdutos(empresaSelecionada, lojistaSelecionado)"
        ></v-select>
      </v-col>
    </v-row>

    <v-row dense v-if="user.tipo == 'ADMIN_PRODUTORA'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="lojistaSelecionado"
          :items="lojistas"
          item-text="nome"
          item-value="id"
          label="Selecione o lojista"
          @input="carregaProdutos(user.empresaId, lojistaSelecionado)"
        ></v-select>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" v-if="tabela.conteudo.length > 0">
        <v-chip-group v-model="filtroSelecionado" mandatory column class="d-flex flex-wrap">
          <v-chip label class="mr-2" dark filter value="TODOS" color="primary">
            <v-icon left>mdi-label</v-icon>
            Total: {{ quantidadeProdutos.total }}
          </v-chip>

          <v-chip label class="mr-2" dark filter value="ATIVOS" color="primary">
            <v-icon left>mdi-label</v-icon>
            Ativos: {{ quantidadeProdutos.ativos }}
          </v-chip>

          <v-chip label class="mr-2" dark filter value="INATIVOS" color="primary">
            <v-icon left>mdi-label</v-icon>
            Inativos: {{ quantidadeProdutos.inativos }}
          </v-chip>

          <v-chip label class="mr-2" dark filter value="EM ESTOQUE" color="primary">
            <v-icon left>mdi-label</v-icon>
            Em estoque: {{ quantidadeProdutos.emEstoque }}
          </v-chip>

          <v-chip label class="mr-2" dark filter value="BAIXO ESTOQUE" color="primary">
            <v-icon left>mdi-label</v-icon>
            Baixo Estoque: {{ quantidadeProdutos.baixoEstoque }}
          </v-chip>

          <v-chip label class="mr-2" dark filter value="SEM ESTOQUE" color="primary">
            <v-icon left>mdi-label</v-icon>
            Sem Estoque: {{ quantidadeProdutos.semEstoque }}
          </v-chip>
        </v-chip-group>
      </v-col>

      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"    
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">ESTOQUE</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <v-chip
              dark
              :color="item.status == 'ativo' ? 'green' : 'red'"
              style="width: 90px;"
            >
              <v-icon left>{{ item.status == "ativo" ? 'mdi-check' : 'mdi-close' }}</v-icon>
              {{ item.status == "ativo" ? 'Ativo' : 'Inativo' }}
            </v-chip>
          </template>

          <template v-slot:[`item.preco`]="{ item }">
            <p style="margin: 0px">R$ {{item.preco}}</p>
          </template>

          <template v-slot:[`item.situacao`]="{ item }">
            <v-chip
              small
              :color="retornaSituacaoProduto(item).cor"
              dark
              style="width: 115px"
            >
              <v-icon
                left
                small
              >
                {{ retornaSituacaoProduto(item).icone }}
              </v-icon>
              {{ retornaSituacaoProduto(item).texto }}
            </v-chip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: {Snackbar},
    data: () => ({
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Produto', value: 'descricao' },
          { text: 'Estoque Atual', value: 'estoque' },
          { text: 'Estoque Mínimo', value: 'estoqueMinimo' },
          { text: 'Status', value: 'status' },
          { text: 'Preço', value: 'preco' },
          { text: 'Situação', value: 'situacao' },
          { text: 'Ações', value: 'action',  sortable: false, align: 'center' },
        ],
        carregamento: false,
        conteudo: [],
      },
      empresaSelecionada: '',
      lojistaSelecionado: '',
      filtroSelecionado: '',
      produtosLojistaSelecionado: [],
      empresas: [],
      produtos: [],
      lojistas: [],
      quantidadeProdutos: {
        total: 0,
        ativos: 0,
        inativos: 0,
        emEstoque: 0,
        baixoEstoque: 0,
        semEstoque: 0,
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitleProd () {
        return this.editedIndex === -1 ? 'Adicionar novo produto' : 'Editar produto'
      },  
    }),

    watch: {
      filtroSelecionado(val) {
        this.filtroTabela(val)
      }
    },

    mounted () {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      }
      else if (this.user.tipo == 'ADMIN_PRODUTORA') {
        this.carregaLojistas(this.user.empresaId)
      }
      else {
        this.carregaProdutos(this.companyobj.id, this.user.lojistaId)
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaLojistas(empresaId) {
        await axios.get(baseApiUrl + 'Lojistas?filter={"where":{"empresaId":"' + empresaId + '"}, "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.lojistas = response.data
          }
        })
      },

      async carregaProdutos(empresaId, lojistaId) {
        this.tabela.carregamento = true
        this.tabela.conteudo = []
        
        await axios.get(baseApiUrl + 'Produtos?filter={"where":{"and":[{"lojistaId":"' + lojistaId + '"}]}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          this.obterIndicadores(response.data)
          this.produtosLojistaSelecionado = response.data
          this.tabela.conteudo = response.data
          this.tabela.carregamento = false
        })
      },

      obterIndicadores(produtos) {
        this.quantidadeProdutos.total = produtos.length
        this.quantidadeProdutos.ativos = produtos.filter(produto => produto.status === 'ativo').length
        this.quantidadeProdutos.inativos = produtos.filter(produto => produto.status === 'inativo').length
        this.quantidadeProdutos.emEstoque = produtos.filter(produto => produto.estoque >= produto.estoqueMinimo).length
        this.quantidadeProdutos.baixoEstoque = produtos.filter(produto => produto.estoque <= produto.estoqueMinimo).length
        this.quantidadeProdutos.semEstoque = produtos.filter(produto => produto.estoque <= 0).length
      },

      retornaSituacaoProduto(produto) {
        if (!produto) return

        if (produto.estoque <= 0) {
          return {
            texto: 'Sem estoque',
            cor: 'red',
            icone: 'mdi-close'
          }
        }

        if (produto.estoque <= produto.estoqueMinimo) {
          return {
            texto: 'Estoque baixo',
            cor: 'orange',
            icone: 'mdi-alert'
          }
        }

        if (produto.estoque > produto.estoqueMinimo) {
          return {
            texto: 'Em estoque',
            cor: 'green',
            icone: 'mdi-check'
          }
        }

        return {
          texto: '',
          cor: '',
          icone: '',
        }
      },

      filtroTabela(tipo) {
        switch (tipo) {
          case 'TODOS':
            this.tabela.conteudo = this.produtosLojistaSelecionado
            break;

          case 'ATIVOS':
            this.tabela.conteudo = this.produtosLojistaSelecionado.filter(produto => produto.status === 'ativo')
            break;

          case 'INATIVOS':
            this.tabela.conteudo = this.produtosLojistaSelecionado.filter(produto => produto.status === 'inativo')
            break;

          case 'EM ESTOQUE':
            this.tabela.conteudo = this.produtosLojistaSelecionado.filter(produto => produto.estoque >= produto.estoqueMinimo)
            break;

          case 'BAIXO ESTOQUE':
            this.tabela.conteudo = this.produtosLojistaSelecionado.filter(produto => produto.estoque <= produto.estoqueMinimo)
            break;

          case 'SEM ESTOQUE':
            this.tabela.conteudo = this.produtosLojistaSelecionado.filter(produto => produto.estoque <= 0)
            break;
        
          default:
            this.tabela.conteudo = this.produtosLojistaSelecionado
            break;
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }
</style>
